var map = {
	"./cloud-based-business-intelligence.md": [
		89,
		89
	],
	"./future-of-business-intelligence.md": [
		321,
		321
	],
	"./power-of-edge-computing.md": [
		772,
		391
	],
	"./role-of-ai-in-automating-bi-insights.md": [
		255,
		636
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 653;
module.exports = webpackAsyncContext;